/**
 * Triggers events when the window is shown or hidden
 */
define('visibility',['lib/event-emitter'], function(EventEmitter) {
	var events = new EventEmitter();
	
    var hidden = "hidden";

    // Standards:
    if (hidden in document)
        document.addEventListener("visibilitychange", onchange);
    else if ((hidden = "mozHidden") in document)
        document.addEventListener("mozvisibilitychange", onchange);
    else if ((hidden = "webkitHidden") in document)
        document.addEventListener("webkitvisibilitychange", onchange);
    else if ((hidden = "msHidden") in document)
        document.addEventListener("msvisibilitychange", onchange);
    // IE 9 and lower:
    else if ('onfocusin' in document)
        document.onfocusin = document.onfocusout = onchange;
    // All others:
    else
        window.onpageshow = window.onpagehide 
            = window.onfocus = window.onblur = onchange;

    function onchange (evt) {
        var v = true, h = false,
            evtMap = { 
                focus:v, focusin:v, pageshow:v, blur:h, focusout:h, pagehide:h 
            };

        evt = evt || window.event;
        var newState;
        if (evt.type in evtMap)
            newState = evtMap[evt.type];
        else        
        	newState = !this[hidden];
        if (newState !== events.isVisible) {
        	events.isVisible = newState;
        	events.emit(newState ? 'show' : 'hide');
        }
        
    }
    // set the initial state
    onchange({type:(document.visibilityState == "visible") ? "focus" : "blur"})
    
    return events;
});

